import { useState, useEffect } from "react";
import { AuthProvider, useAuth } from "./context/AuthContext";
import PayrollApp from "./payroll/PayrollApp";
import Landing from "./pages/Landing";
import Dashboard from "./pages/Dashboard";
import ReportMonitor from "./pages/agents/ReportMonitor";
import PriceMonitor from "./pages/agents/PriceMonitor";
import Employees from "./pages/Employees";
import Schedule from "./pages/Schedule";
import PayrollEmployees from "./pages/payroll/Employees";
import PayrollShifts from "./pages/payroll/Shifts";
import PayrollAdjustments from "./pages/payroll/Adjustments";
import PayrollPayroll from "./pages/payroll/Payroll";
import PayrollStats from "./pages/payroll/Stats";
import Sidebar from "./components/Sidebar";
import "./App.css";

function AppInner() {
  const { user, loading } = useAuth();
  const [activePage, setActivePage] = useState("dashboard");
  const [payrollTab, setPayrollTab] = useState("employees");

  if (loading) return (
    <div style={{ display:"flex", alignItems:"center", justifyContent:"center", height:"100vh", background:"#012624", color:"#00d2b4", fontSize:14, letterSpacing:"0.15em" }}>
      THOTH AI LOADING...
    </div>
  );

  if (!user) return <Landing />;

  const renderPage = () => {
    switch(activePage) {
      case "dashboard":     return <Dashboard />;
      case "agent-reports": return <ReportMonitor />;
      case "agent-prices": return <PriceMonitor />;
      case "employees":     return <Employees />;
      case "schedule":      return <Schedule />;
      case "payroll":       return <PayrollSection tab={payrollTab} setTab={setPayrollTab} />;
      default:              return <Dashboard />;
    }
  };

  return (
    <div className="app">
      <Sidebar activePage={activePage} setActivePage={setActivePage} user={user} />
      <main className="main-content">{renderPage()}</main>
    </div>
  );
}

const PAYROLL_TABS = [
  { key: "employees",    label: "Сотрудники" },
  { key: "shifts",       label: "Табель" },
  { key: "adjustments",  label: "Штрафы и плюсы" },
  { key: "payroll",      label: "Ведомость" },
  { key: "stats",        label: "Статистика" },
];

function PayrollSection({ tab, setTab }) {
  const renderTab = () => {
    switch(tab) {
      case "employees":   return <PayrollEmployees />;
      case "shifts":      return <PayrollShifts />;
      case "adjustments": return <PayrollAdjustments />;
      case "payroll":     return <PayrollPayroll />;
      case "stats":       return <PayrollStats />;
      default:            return <div style={{padding:40,color:"#6b7280"}}>Раздел в разработке</div>;
    }
  };

  return (
    <div style={{ display:"flex", flexDirection:"column", height:"100%" }}>
      <div style={{ display:"flex", gap:4, padding:"16px 24px 0", borderBottom:"1px solid #e5e7eb", background:"#fff" }}>
        {PAYROLL_TABS.map(t => (
          <button
            key={t.key}
            onClick={() => setTab(t.key)}
            style={{
              padding:"10px 20px", border:"1px solid transparent",
              borderBottom:"none", borderRadius:"8px 8px 0 0",
              fontSize:14, fontWeight:500, cursor:"pointer",
              background: tab === t.key ? "#fff" : "transparent",
              color: tab === t.key ? "#111827" : "#6b7280",
              borderColor: tab === t.key ? "#e5e7eb" : "transparent",
              marginBottom: tab === t.key ? -1 : 0,
            }}
          >
            {t.label}
          </button>
        ))}
      </div>
      <div style={{ flex:1, padding:24, overflowY:"auto", background:"#f9fafb" }}>
        {renderTab()}
      </div>
    </div>
  );
}

import ReconciliationApp from "./reconciliation/ReconciliationApp";
export default function App() {
  const isPayrollRoute = window.location.pathname.startsWith("/payroll");
  const isReconRoute   = window.location.pathname.startsWith("/reconciliation");
  if (isPayrollRoute) return <PayrollApp />;
  if (isReconRoute)   return <ReconciliationApp />;
  return (
    <AuthProvider>
      <AppInner />
    </AuthProvider>
  );
}
